import { FormDetailsTranslations } from './types';

export const enTranslations: FormDetailsTranslations = {
    classNameLabel: "Class name:",
    patientCountLabel: "Patient count:",
    arrivalIntervalLabel: "Patient arrival interval:",
    classNamePlaceholder: "e.g. Intro class"
};